<template>
  <ul class="mobile-menu">
    <li class="mobile-menu__link-wrapper">
      <div class="mobile-menu__link">
        <span>Learning Areas</span>
        <div
          class="mobile-menu__link-arrow-wrapper"
          @click="
            ;(isLearningAreasActive = !isLearningAreasActive),
              (currentCategory = '')
          "
        >
          <span
            :class="
              isLearningAreasActive ? 'mobile-menu__link-arrow--active' : ''
            "
            class="mobile-menu__link-arrow material-icons"
            >keyboard_arrow_right</span
          >
        </div>
      </div>
      <transition name="slide">
        <Categories
          @closeMegaMenu="$emit('closeMegaMenu')"
          @toggleCurrentCategory="toggleCurrentCategory"
          :categories="categories"
          :currentCategory="currentCategory"
          :isLearningAreasActive="isLearningAreasActive"
          :getCategoryDetails="getCategoryDetails"
          :openCategorySearch="openCategorySearch"
        />
      </transition>
    </li>
    <li class="mobile-menu__link-wrapper mobile-menu__learning-path">
      <router-link
        :to="{ name: 'learning-paths' }"
        @click.native="$emit('closeMegaMenu')"
        class="mobile-menu__link"
        >Learning Paths</router-link
      >
    </li>
  </ul>
</template>
<script>
import Categories from './Categories.vue'

export default {
  name: 'MobileMegaMenu',
  components: {
    Categories,
  },
  data() {
    return {
      isLearningAreasActive: false,
      currentCategory: '',
    }
  },
  props: {
    categories: {
      type: Array,
      required: true,
    },
    getCategoryDetails: {
      type: Function,
      required: true,
    },
    openCategorySearch: {
      type: Function,
      required: true,
    },
  },
  methods: {
    toggleCurrentCategory(category) {
      if (category !== this.currentCategory) {
        this.currentCategory = category
      } else {
        this.currentCategory = ''
      }
    },
  },
}
</script>
<style lang="scss" scoped>
$mobile: 320px;
$tablet: 769px;
$desktop: 1024px;
$lg_desktop: 1300px;
.mobile-menu {
  $this: &;
  display: block;
  margin: 0;
  padding: 0;
  @media screen and (min-width: $tablet) {
    display: none;
  }
  &__learning-path {
    #{$this}__link {
      height: 59px;
    }
  }
  &__link-wrapper {
    position: relative;
    background: #151515;
    font-size: (18 / 16) * 1rem;
    color: var(--white);
    display: block;
  }
  &__link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #222;
    padding: 0 0 0 40px;
    color: var(--white);
  }
  &__link-arrow-wrapper {
    padding: 16px 20px;
    border-left: 1px solid #222;
  }
  &__link-arrow {
    font-size: (20 / 16) * 1rem;
    color: var(--white);
    transform: translateZ(0);
    transition: all 0.2s ease-out;
    &--active {
      transform: rotateZ(180deg);
    }
  }
}

.slide-enter-active {
  transition-duration: 0.3s;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 200px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
